import { usePostOfficeContext } from '@atlassian/post-office-context/post-office-context';

import { productNames } from './constants';

export const useIsWacContext = (): boolean => {
	const context = usePostOfficeContext();
	return context.product === productNames.WAC;
};
